module.exports = __webpack_public_path__ + "img/back-to-list.5fda1464.svg";